import {
  useMemo,
  Children,
  isValidElement,
  cloneElement,
  ReactElement,
} from 'react';
import { ListboxItem, TListboxItem } from './ListboxItem';
import { useStore } from './useStore';

export function useIndexedChildren(
  children: React.ReactNode | React.ReactNode[],
  listboxActions: ReturnType<typeof useStore>[0],
) {
  return useMemo(
    function makeChildrenIndices() {
      listboxActions.resetFocus(null);

      return Children.map(children, (child, rowIndex) => {
        if (isValidElement(child) && child.type === ListboxItem) {
          return cloneElement<TListboxItem>(
            child as ReactElement<TListboxItem>,
            {
              rowIndex,
            },
          );
        }
        return child;
      });
    },
    [children, listboxActions],
  );
}
